import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../auth/services/auth.service';
import { DataFiltersService } from '../../services/data-filters.service';
import { CitiesService } from '../../services/cities.service';
import { CategoryService } from '../../services/categories.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'mpro-categories-switch',
  templateUrl: './categories-switch.component.html',
  styleUrls: ['./categories-switch.component.scss'],
})
export class CategoriesSwitchComponent implements OnInit, OnDestroy {
  public enableToggle: boolean;
  public isOn: boolean = false;
  private isCitiesEnabled: boolean = true;
  private ngUnsubscribe: Subject<void> = new Subject();

  enableCategories(val: boolean) {
    this.authService.switchCategoriesConsumerDemand(!val);
  }

  constructor(
    public authService: AuthService,
    public dataFiltersService: DataFiltersService,
    public citiesService: CitiesService,
    public categoriesService: CategoryService
  ) {
    this.authService.permissions$.subscribe((permission) => {
      this.enableToggle = permission.categories.length !== 0;
    });
  }

  ngOnInit(): void {
    this.authService.categoriesEnabled$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isOn) => {
        this.isOn = isOn;
        this.dataFiltersService.resetCategories();
        this.dataFiltersService.resetGender();
        if (this.isOn) {
          if (this.isCitiesEnabled) {
            this.dataFiltersService.resetCity();
          } else {
            this.dataFiltersService.resetLocation();
          }
          this.citiesService.getCities$.next(undefined);
          return;
        }
      });
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
